import Subnav from './Subnav';
const els = document.querySelectorAll('.subnav:not(.subnav--submenu)');

for (let el of els) {
    Subnav(el);
};
